import React, { Suspense } from "react";
import classNames from "classnames/bind";

import styles from "./InputPhone.module.css";

const cx = classNames.bind(styles);

const PhoneInput = React.lazy(() => import("react-phone-number-input"));

type Props = {
  label: string;
  value: string;
  required?: boolean;
  error?: string;
  onChange: (value: string) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  type?: string;
  disabled?: boolean;
  readOnly?: boolean;
  name: string;
};

export const InputPhone: React.FC<Props> = (props) => {
  const { label, value, required, error, onChange, disabled, onBlur, onFocus } = props;

  return (
    <label
      className={cx("field", {
        field_filled: !!value,
      })}
    >
      <Suspense fallback={() => null}>
        <PhoneInput
          numberInputProps={{
            className: cx("input"),
          }}
          value={value}
          disabled={disabled}
          onChange={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
        />
      </Suspense>

      {label && (
        <span className={cx("label")}>
          {label}
          {required && <span className={cx("required")}>*</span>}
        </span>
      )}

      {error && <span className={cx("error")}>{error}</span>}
    </label>
  );
};
